import { Component } from '@angular/core';
import { SideMenuComponent } from '../side-menu/side-menu.component';
import { TranslateModule } from '@ngx-translate/core';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-company-milestone',
  standalone: true,
  imports: [SideMenuComponent, TranslateModule],
  templateUrl: './company-milestone.component.html',
  styleUrl: './company-milestone.component.css'
})
export class CompanyMilestoneComponent {

  baseApiUrl = environment.baseApiUrl;

}
